import React from 'react';
import esriStrings from '../../resources/esriStrings';

const CtaButton = (props) =>
        <a
        className="cta-button btn btn-large"
        data-event="track-component"
        data-component-name={'Learn More Button'}
        data-component-link={'Open Learn More Form'}
        data-component-link-placement="1"
        data-component-link-type="title"
        href="https://oneform-modal.esri.com?formName=ArcGIS%20-%20Promotions%20-%20Awareness%3A%20Gartner%20Showcase%20App%3A%20LPG-ov"

      >
                  {esriStrings.ctaButtonText}
      </a>;


export default CtaButton;
